module.exports = __webpack_public_path__ + "img/pic_tltw_pszsy_normal@2x.e43d5e94.png";